import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('QRReceptionPoint')
export class QRReceptionPoint {
  @JsonProperty('Code', String)
  public Code: string | undefined = undefined;
  @JsonProperty('City', String)
  public City: string | undefined = undefined;
  @JsonProperty('Country', String)
  public Country: string | undefined = undefined;
}

@JsonObject('QRCause')
export class QRCause {
  @JsonProperty('CommandId', Number)
  public Id: number | undefined = undefined;
  @JsonProperty('Text', String)
  public Text: string | undefined = undefined;
}

@JsonObject('QRExtRestriction')
export class QRExtRestriction {
  @JsonProperty('1', String)
  public Organization: string | undefined = undefined;
  @JsonProperty('2', String)
  public Date: string | undefined = undefined;
}

@JsonObject('QRDepartureRestrictions')
export class QRDepartureRestrictions {
  @JsonProperty('1', QRExtRestriction)
  public SecretAccess: QRExtRestriction | undefined = undefined;
  @JsonProperty('2', QRExtRestriction)
  public ContractObligation: QRExtRestriction | undefined = undefined;
  @JsonProperty('3', Boolean)
  public MilitaryService: boolean | undefined = undefined;
  @JsonProperty('4', Boolean)
  public Convicted: boolean | undefined = undefined;
  @JsonProperty('5', Boolean)
  public Accused: boolean | undefined = undefined;
  @JsonProperty('6', Boolean)
  public EvadingLaw: boolean | undefined = undefined;
  @JsonProperty('7', Boolean)
  public Bankrupt: boolean | undefined = undefined;
}

@JsonObject('QRPersonAddress')
export class QRPersonAddress {
  @JsonProperty('1', String)
  public Country: string | undefined = undefined;
  @JsonProperty('2', String)
  public AdmDivision: string | undefined = undefined;
  @JsonProperty('3', String)
  public Region: string | undefined = undefined;
  @JsonProperty('4', String)
  public Settlement: string | undefined = undefined;
  @JsonProperty('5', String)
  public Street: string | undefined = undefined;
  @JsonProperty('6', String)
  public Building: string | undefined = undefined;
  @JsonProperty('7', String)
  public Housing: string | undefined = undefined;
  @JsonProperty('8', String)
  public Structure: string | undefined = undefined;
  @JsonProperty('9', String)
  public Flat: string | undefined = undefined;
}

@JsonObject('QRPeriod')
export class QRPeriod {
  @JsonProperty('1', String)
  public From: string | undefined = undefined;
  @JsonProperty('2', String)
  public To: string | undefined = undefined;
}

@JsonObject('QRNameChange')
export class QRNameChange {
  @JsonProperty('1', String)
  public FirstName: string | undefined = undefined;
  @JsonProperty('2', String)
  public MiddleName: string | undefined = undefined;
  @JsonProperty('3', String)
  public LastName: string | undefined = undefined;
  @JsonProperty('4', String)
  public ChangeDate: string | undefined = undefined;
  @JsonProperty('5', String)
  public Location: string | undefined = undefined;
}

@JsonObject('QRLocationAddress')
export class QRLocationAddress {
  @JsonProperty('1', QRPersonAddress)
  public Address: QRPersonAddress | undefined = undefined;
  @JsonProperty('2', Boolean)
  public IsReal: boolean | undefined = undefined;
  @JsonProperty('3', QRPeriod)
  public Period: QRPeriod | undefined = undefined;
}

@JsonObject('QRResidenceAddress')
export class QRResidenceAddress {
  @JsonProperty('1', QRPersonAddress)
  public Address: QRPersonAddress | undefined = undefined;
  @JsonProperty('2', String)
  public Date: string | undefined = undefined;
}

@JsonObject('QRJobRecord')
export class QRJobRecord {
  @JsonProperty('1', String)
  public Job: string | undefined = undefined;
  @JsonProperty('2', String)
  public Address: string | undefined = undefined;
  @JsonProperty('3', String)
  public DateFrom: string | undefined = undefined;
  @JsonProperty('4', String)
  public DateTo: string | undefined = undefined;
}

@JsonObject('QRIdentityDocumentType')
export class QRIdentityDocumentType {
  @JsonProperty('Id', Number)
  public Id: number | undefined = undefined;
  @JsonProperty('Text', String)
  public Text: string | undefined = undefined;
}

@JsonObject('QRIdentityDocument')
export class QRIdentityDocument {
  @JsonProperty('IssueDate', String)
  public IssueDate: string | undefined = undefined;
  @JsonProperty('Issuer', String)
  public Issuer: string | undefined = undefined;
  @JsonProperty('Number', String)
  public Number: string | undefined = undefined;
  @JsonProperty('Series', String)
  public Series: string | undefined = undefined;
  @JsonProperty('Type', QRIdentityDocumentType)
  public Type: QRIdentityDocumentType | undefined = undefined;
}

@JsonObject('QRGender')
export class QRGender {
  @JsonProperty('Id', Number)
  public Id: number | undefined = undefined;
  @JsonProperty('Text', String)
  public Text: string | undefined = undefined;
}

@JsonObject('QRForeignPassport')
export class QRForeignPasport {
  @JsonProperty('2', String)
  public Series: string | undefined = undefined;
  @JsonProperty('3', String)
  public Number: string | undefined = undefined;
  @JsonProperty('4', String)
  public IssueDate: string | undefined = undefined;
  @JsonProperty('6', String)
  public Issuer: string | undefined = undefined;
  @JsonProperty('12', Boolean)
  public MustBeCanceled: boolean | undefined = undefined;
  @JsonProperty('13', Boolean)
  public Lost: boolean | undefined = undefined;
}

@JsonObject('_FullName')
export class _FullName {
  @JsonProperty('1', String)
  public LastName: string | undefined = undefined;
  @JsonProperty('2', String)
  public FirstName: string | undefined = undefined;
  @JsonProperty('3', String)
  public MiddleName: string | undefined = undefined;
}

@JsonObject('_PersonIdentity')
export class _PersonIdentity {
  @JsonProperty('1', _FullName)
  public FullName: _FullName | undefined = undefined;
  @JsonProperty('2', String)
  public BirthDate: string | undefined = undefined;
  @JsonProperty('3', String)
  public PrintBirthDate: string | undefined = undefined;
}

@JsonObject('_Person')
export class _Person {
  @JsonProperty('1', _PersonIdentity)
  public PersonIdentity: _PersonIdentity | undefined = undefined;
  @JsonProperty('2', Number)
  public Gender: number | undefined = undefined;
  @JsonProperty('3', String)
  public BirthPlace: string | undefined = undefined;
}

@JsonObject('_IdentityDocument')
export class _IdentityDocument {
  @JsonProperty('Type', Number)
  public Type: number | undefined = undefined;
  @JsonProperty('Series', String)
  public Series: string | undefined = undefined;
  @JsonProperty('Number', String)
  public Number: string | undefined = undefined;
  @JsonProperty('Issuer', String)
  public Issuer: string | undefined = undefined;
  @JsonProperty('IssueDate', String)
  public IssueDate: string | undefined = undefined;
}

@JsonObject('QRPerson')
export class QRPerson {
  @JsonProperty('1', String)
  public FirstName: string | undefined = undefined;
  @JsonProperty('2', String)
  public MiddleName: string | undefined = undefined;
  @JsonProperty('3', String)
  public LastName: string | undefined = undefined;
  @JsonProperty('4', String)
  public FirstNameLat: string | undefined = undefined;
  @JsonProperty('5', String)
  public LastNameLat: string | undefined = undefined;
  @JsonProperty('9', String)
  public BirthPlaceRus: string | undefined = undefined;
  @JsonProperty('10', String)
  public BirthPlaceLat: string | undefined = undefined;
  @JsonProperty('11', String)
  public Birthdate: string | undefined = undefined;
  @JsonProperty('12', QRGender)
  public Gender: QRGender | undefined = undefined;
  @JsonProperty('14', String)
  public Phone: string | undefined = undefined;
  @JsonProperty('17', [QRForeignPasport])
  public ForeignPassports: QRForeignPasport[] | undefined = undefined;
  @JsonProperty('18', [QRNameChange])
  public NameChanges: QRNameChange[] | undefined = undefined;
  @JsonProperty('19', QRIdentityDocument)
  public IdentityDocument: QRIdentityDocument | undefined = undefined;
  @JsonProperty('20', [QRJobRecord])
  public JobHistory: QRJobRecord[] | undefined = undefined;
  @JsonProperty('25', String)
  public BirthPlaceFull: string | undefined = undefined;
  @JsonProperty('26', Number)
  public BirthDateCompleteness: number | undefined = undefined;
  @JsonProperty('27', String)
  public Email: string | undefined = undefined;
  @JsonProperty('28', QRIdentityDocument)
  public RepresentativeProof: QRIdentityDocument | undefined = undefined;
  @JsonProperty('29', _Person)
  public TrustRecepient: _Person | undefined = undefined;
  @JsonProperty('30', QRLocationAddress)
  public LocationAddress: QRLocationAddress | undefined = undefined;
  @JsonProperty('31', QRResidenceAddress)
  public ResidenceAddress: QRResidenceAddress | undefined = undefined;
}

@JsonObject('QRMailingInfo')
export class QRMailingInfo {
  @JsonProperty('1', Boolean)
  public Active: boolean | undefined = undefined;
  @JsonProperty('2', String)
  public Track: string | undefined = undefined;
  @JsonProperty('3', String)
  public ServiceId: string | undefined = undefined;
  @JsonProperty('4', String)
  public ServiceName: string | undefined = undefined;
  @JsonProperty('5', String)
  public AddressRus: string | undefined = undefined;
  @JsonProperty('6', String)
  public AddressLat: string | undefined = undefined;
}

@JsonObject('QRSourceInfo')
export class QRSourceInfo {
  @JsonProperty('WebSiteVersion', String)
  public WebSiteVersion: string | undefined = undefined;
}

@JsonObject('QRApplication')
export class QRApplication {
  @JsonProperty('1', QRCause)
  public Cause: QRCause | undefined = undefined;
  @JsonProperty('3', QRPerson)
  public Person: QRPerson = new QRPerson();
  @JsonProperty('4', QRPerson)
  public ChildRepresentative: QRPerson | undefined = undefined;
  @JsonProperty('12', String)
  public JobDate: string | undefined = undefined;
  @JsonProperty('13', String)
  public JobMan: string | undefined = undefined;
  @JsonProperty('15', String)
  public ApplicantDate: string | undefined = undefined;
  @JsonProperty('SourceInfo', QRSourceInfo)
  public SourceInfo: QRSourceInfo | undefined = undefined;
  @JsonProperty('21', QRDepartureRestrictions)
  public DepartureRestrictions: QRDepartureRestrictions | undefined = undefined;
  @JsonProperty('22', _IdentityDocument)
  public IndependedChildDocument: _IdentityDocument | undefined = undefined;
}

@JsonObject('QRReq')
export class QRReq {
  @JsonProperty('3', QRReceptionPoint)
  public ReceptionPoint: QRReceptionPoint | undefined = undefined;
  @JsonProperty('4', QRApplication)
  public Application: QRApplication = new QRApplication();
  @JsonProperty('11', QRMailingInfo)
  public MailPass: QRMailingInfo | undefined = undefined;
  @JsonProperty('15', Boolean)
  public Incapable: boolean | undefined = undefined;
  @JsonProperty('16', Boolean)
  public IndependentChild: boolean | undefined = undefined;
}
